<template>
  <div>
    <b-container>
      <transition name="fade">
        <ProductsList scope="sb" :total="getTotal" :selected-product-data="getProduct" :selected-product-docs="getDocs" :products="getProducts" @on-product-select="showProduct(...arguments)" @on-click-load-more="loadMore">
          <template #ingress>
            <h2 class="d-print-none">{{ products_slutbleck_title }}</h2>
            <p class="d-print-none">{{ products_slutbleck_text }}</p>
          </template>
        </ProductsList>
      </transition>
    </b-container>
  </div>
</template>

<script>
  import store from "@/store/store";
  import { mapGetters, mapActions } from "vuex";
  import productsListMixin from "@/mixins/productsListMixin";
  import contentMixin from "@/mixins/contentMixin";
  export default {
    name: "ProductsListViewSB",
    mixins: [productsListMixin, contentMixin],
    computed: {
      ...mapGetters("productsSB", ["getProducts", "getCount", "getTotal"]),
      ...mapGetters("productSB", ["getProduct", "getDocs"]),
    },
    methods: {
      ...mapActions("productsSB", ["fetchProducts"]),
      ...mapActions("productSB", ["fetchProduct", "fetchDocsForArt"]),
      loadMore() {
        this.$store.dispatch("productsSB/updateSkip");
      },
    },
    beforeRouteEnter(to, from, next) {
      // Reset pagination
      store.dispatch("productsSB/resetSkip");
      // Reset selected product
      store.dispatch("productSB/resetProduct");
      store
        .dispatch("productsSB/fetchProducts")
        .then(() => next())
        .catch((error) => {
          if (error.response && error.response.status == 404) {
            next({ name: "404", params: { resource: "event" } });
          } else {
            next({ name: "network-issue" });
          }
        });
    },
    beforeRouteUpdate(to, from, next) {
      store.dispatch("productsSB/fetchProducts").then(() => {
        next();
      });
    },
  };
</script>

<style lang="scss" scoped></style>
